import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { HeroUIProvider } from "@heroui/react";

import * as Sentry from "@sentry/react";

// Only initialize Sentry in production (when RENDER environment variable is set)
const isProduction = import.meta.env.VITE_RENDER || import.meta.env.RENDER;

if (isProduction) {
  Sentry.init({
    dsn: "https://22db979f57d0c5b9e8c12350d9c70043@o4510113519239168.ingest.de.sentry.io/4510113520353360",
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    environment: 'production',
    sendDefaultPii: true,
    integrations: [
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      })
    ],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
  
  console.log('✅ Sentry initialized for production environment');
} else {
  console.log('ℹ️ Sentry disabled in development environment');
}

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <HeroUIProvider>
      <App />
    </HeroUIProvider>
  </React.StrictMode>
);
